module.exports = __webpack_public_path__ + "static/image1-4a19862971c4bc82928ad0d25bc20252.png";